module.exports = __webpack_public_path__ + "img/Sad.abca2ff3.png";